export enum OnboardingAction {
	NEXT = 'next',
	DONE = 'done',
	SKIP = 'skip',
	BACK = 'back',
	CANCEL = 'cancel',
}
